import {useMemo} from 'react'
import {useQuery} from '@tanstack/react-query'

import {ONE_MINUTE} from '#/lib/constants.ts'
import {useAgent} from '#/state/session'
import {type WsocialProfile} from '#/wsocial/types/profile.ts'

export const useSessionData = () => {
  const agent = useAgent()
  return useQuery({
    queryKey: ['curr-user-session', agent?.session?.did],
    queryFn: async () => {
      const {data} = await agent.com.atproto.server.getSession()
      return data
    },
    enabled: !!agent?.session?.did,
    staleTime: ONE_MINUTE,
  })
}

export function useWsocialVerifiedSession(): string | null | boolean {
  const {data: session} = useSessionData()
  return useMemo(() => {
    if (session) {
      const {wsocialVerified} = session as WsocialProfile
      return wsocialVerified ?? false
    }
    return null
  }, [session])
}
